module.exports = __webpack_public_path__ + "img/map_4.fe4f7c35.webp";